/**
 * A group of toggle buttons that narrows a list to the values picked — tags,
 * mostly. The screen owns the selection; this only reports the next one.
 */
export function FilterChips({
  label,
  options,
  selected,
  onChange,
}: {
  /** The group's accessible name. */
  label: string;
  options: readonly string[];
  selected: readonly string[];
  onChange: (selected: string[]) => void;
}) {
  return (
    <div role="group" aria-label={label} className="filter-chips">
      {options.map((option) => {
        const on = selected.includes(option);
        return (
          <button
            key={option}
            type="button"
            aria-pressed={on}
            className={on ? 'filter-chip is-active' : 'filter-chip'}
            onClick={() =>
              onChange(
                on
                  ? selected.filter((s) => s !== option)
                  : [...selected, option],
              )
            }
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}
